/* eslint-disable no-undef */
/* eslint-disable import/no-anonymous-default-export */
import React, { useState } from "react";
import Post from "./Post";
import PostPlaceHolder from "./PostPlaceHolder/";
import { Link } from "react-router-dom";
import "./styles.scss";
import ActivityFilters from "../NewsFeed/ActivityFilters";
import { isSelfId } from "../../../api/helper";
import { removeMediumFromSingle } from "../../../api/sound_tracks";
import MediaFlatItemSingle from "../../shared/MediaFlatitemsingle";
import hv_player_api from "../../../api/hv_player_api";
import RemoveSinglesConfimModal from "../Profile/ProfileBody/Singles/RemoveSinglesConfimModal";

const PostsList = (props) => {
  const { onFilterClick, filter, setObject } = props;
  const [show, setShow] = useState(false);
  const [id, setId] = useState(null);

  const onRemoveMedium = (medium) => {
    setShow(true);
    setId(medium);
  };

  const removeMedium = async () => {
    try {
      await removeMediumFromSingle(id);
      setShow(false);
      onFilterClick(filter);
    } catch (error) {}
  };
  return (
    <div id="timeline" className="timeline m-md-4">
      {!!props.activityFillters && <ActivityFilters user={props.user} onFilterClick={props.onFilterClick} />}
      {props.posts ? (
        props.posts.length ? (
          props.posts.map((post) => {
            return post.type === "SoundTrack" ? (
              <MediaFlatItemSingle
                media={props.posts}
                key={post.id.toString()}
                eventKey={post.id.toString()}
                activeEventKey={post.id.toString()}
                source={{ id: post?.id, type: post?.type }}
                sourceOwner={post.user}
                medium={post}
                setObject={setObject}
                onRemoveMedium={() => onRemoveMedium(post.id)}
                onRemoveFromQueue={hv_player_api.removeFromQueue}
                onAddToQueue={hv_player_api.addToQueue}
              />
            ) : (
              <Post refresh={props.refresh} key={post.id} showActions post={post} setPost={props.postsSetter} postsDeleter={props.postsDeleter} />
            );
          })
        ) : (
          <div className="text-center no-posts">
            <p className="text-primary my-4">
              {!!props.activityFillters ? (
                <>
                  {isSelfId(props.user?.id) ? (
                    <>
                      You don't have any posts yet! Get started today by creating one and sharing an update, new release or demo, new tour date, new
                      podcast, or whatever you want by going to your {<Link to="/">Newsfeed</Link>}.
                    </>
                  ) : (
                    <>
                      No posts just yet from {props.user?.username}! Hit the {<strong>Follow</strong>} button above to see new posts from them in your{" "}
                      {<Link to="/">Newsfeed</Link>} once they're shared.
                    </>
                  )}
                </>
              ) : (
                <>
                  {isSelfId(props.user?.id) ? "You " : props.user?.username + " "}
                  don't have any posts yet. Get started by creating one here in your <Link to="/">Newsfeed</Link>.
                </>
              )}
            </p>
          </div>
        )
      ) : (
        <>
          <PostPlaceHolder />
          <PostPlaceHolder />
          <PostPlaceHolder />
        </>
      )}

      {show && <RemoveSinglesConfimModal show={show} removeMedium={removeMedium} hide={() => setShow(false)} />}
    </div>
  );
};

export default PostsList;
